export const PERSONALIZED_CREATIVE_ID = 'edm-entry-global-nav-semantic-search';
export const HEADER_COMPONENT = 'edm-entry-header-component';
export const OPINION_COMPONENT = 'edm-entry-opinion-component';
export const HIGHLIGHTS_COMPONENT = 'edm-entry-highlights-component';
export const LEAD_CTA_COMPONENT = 'edm-entry-leads-cta-component';
export const ANCHOR_COMPONENT = 'edm-entry-anchor-component';
export const INVENTORY_COMPONENT = 'edm-entry-inventory-component';
export const EDMUNDS_TESTED_COMPONENT = 'edm-entry-edmunds-tested-component';
export const FIND_BEST_PRICE_FORM_NAME = 'find_best_price_multi_drawer';
export const FALLBACK_RESULT_CREATIVE_ID = 'fallback-result';
export const EXPIRED_KEY_RESULT_CREATIVE_ID = 'expired-key-result';
export const LEARN_MORE_COMPONENT_CREATIVE_ID = 'edm-entry-sources-component';
export const LINKS_COMPONENT_CREATIVE_ID = 'edm-entry-links-component';
export const VERDICT_COMPONENT_CREATIVE_ID = 'edm-entry-verdict-component';
